// utils/documentAccess.ts
import { auth, functions } from "@/services/firebase/config";
import { httpsCallable } from "firebase/functions";

interface CheckAccessParams {
  action: 'view' | 'download' | 'upload' | 'edit' | 'delete';
  documentId?: string;
  category?: 'institucional' | 'academico' | 'informativo';
}

interface CheckAccessResult {
  allowed: boolean;
  role: string;
  userId: string;
  orgUnit: string;
}

interface SetAttendantClaimsParams {
  uid: string;
}

interface SetAttendantClaimsResult {
  success: boolean;
  uid: string;
}

interface SetupInstitutionalUserParams {
  email: string;
}

interface SetupInstitutionalUserResult {
  success: boolean;
  uid: string;
  orgUnit: string;
  role: string;
  displayName: string;

}

// Nueva función de validación
export async function validateDocumentAccess(
  params: CheckAccessParams
): Promise<CheckAccessResult> {
  // Asegurar setup primero

  const checkAccess = httpsCallable<CheckAccessParams, CheckAccessResult>(
    functions,
    "checkDocumentAccess"
  );

  try {
    const result = await checkAccess(params);
    return result.data;
  } catch (error: any) {
    console.error("Error validación:", error);
    throw new Error(error.message || "Error de permisos");
  }
}

// Set attendant claims for a user
export async function setAttendantClaims(
  params: SetAttendantClaimsParams
): Promise<SetAttendantClaimsResult> {
  const user = auth.currentUser;
  if (!user) throw new Error("No autenticado");

  const setAttendantClaimsFunc = httpsCallable<SetAttendantClaimsParams, SetAttendantClaimsResult>(
    functions,
    "setAttendantClaims"
  );

  try {
    const result = await setAttendantClaimsFunc(params);
    return result.data;
  } catch (error: any) {
    console.error("Error setting attendant claims:", error);
    throw new Error(error.message || "Error al establecer permisos de asistente");
  }
}

// Setup institutional user with email parameter
export async function setupInstitutionalUser(
  params: SetupInstitutionalUserParams
): Promise<SetupInstitutionalUserResult> {
  const user = auth.currentUser;
  if (!user) throw new Error("No autenticado");

  const setupUserFunc = httpsCallable<SetupInstitutionalUserParams, SetupInstitutionalUserResult>(
    functions,
    "setupInstitutionalUser"
  );

  try {
    const result = await setupUserFunc(params);
    return result.data;
  } catch (error: any) {
    console.error("Error setting up institutional user:", error);
    throw new Error(error.message || "Error al configurar usuario institucional");
  }
}